import { render, staticRenderFns } from "./TheParsingModal.vue?vue&type=template&id=35f72c9c&"
import script from "./TheParsingModal.vue?vue&type=script&lang=js&"
export * from "./TheParsingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports